<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="teacherReassignForm">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>Reassign Final Examiner</b></h3>
                        <p class="text-muted card-sub-title mb-0">Select a new teacher for the final slot</p>
                    </div>
                </div>
                <hr>

                <!-- Search box -->
                <div class="row clearfix">
                    <div class="col-sm-12">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Search Teacher</mat-label>
                            <input matInput formControlName="search" placeholder="Name, College, Designation...">
                        </mat-form-field>
                    </div>
                </div>

                <!-- Table -->
                <div class="table-responsive table-container">
                    <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                        <thead>
                            <tr>
                                <th class="f600 text-center" width="5%">Select</th>
                                <th class="f600 text-left" width="20%">Teacher Name</th>
                                <th class="f600 text-left" width="20%">College</th>
                                <th class="f600 text-left" width="15%">Designation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let teacher of filteredCandidates">
                                <td class="text-center">
                                    <input type="radio" 
                                           name="selectedTeacher"
                                           [value]="teacher.TechId"
                                           [formControl]="teacherReassignForm.get('selectedTeacherId')">
                                </td>
                                <td>{{ teacher.TeacherName }}</td>
                                <td>{{ teacher.TeacherCgCode }}</td>
                                <td>{{ teacher.TeacherType }}</td>
                            </tr>
                            <tr *ngIf="filteredCandidates.length === 0">
                                <td colspan="4" class="text-center text-muted">No eligible teachers found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-sm-12 row mt-3">
                    <div class="col-sm-12 prpl">
                        <button id="Back" type="button" (click)="closeDialog()"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Cancel
                            </span>
                        </button>
                        <button id="Submit" type="button"
                            class="btn btn-primary btn-icon-text floatright mt-1"
                            (click)="submitFinalReassign()"
                            [disabled]="!teacherReassignForm.get('selectedTeacherId').value">
                            <span style="display: contents; align-items: center;">
                                <i class="fas fa-exchange-alt" style="margin-right: 5px;"></i>
                                Reassign Final
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>